import { render, staticRenderFns } from "./ViewFullNoteModal.vue?vue&type=template&id=1a194b2e&"
import script from "./ViewFullNoteModal.vue?vue&type=script&lang=js&"
export * from "./ViewFullNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports